<!--
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2021-12-03 10:48:04
 * @LastEditors: ws2044 a3131854594@163.com
 * @LastEditTime: 2025-06-30 10:09:58
 * @FilePath: \gj_ai_editor\src\layout\components\AppMain.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
// .app-main {
//   /* 50= navbar  50  */
//   min-height: calc(100vh - 50px);
//   width: 100%;
//   position: relative;
//   overflow: hidden;
//   background-color: #fff;
//   border-left: 20px solid #EDEFF2;
//   border-right: 20px solid #EDEFF2;
//   border-top: 75px solid #EDEFF2;
//   border-bottom: 20px solid #EDEFF2;
// }

.app-main {
  /* 50= navbar  50  */
  // min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #eeeffa;
}

.fixed-header+.app-main {
  // padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: 100vh;
  }

  .fixed-header+.app-main {
    // padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
